import axios from "axios";
import authHeader from "@/services/auth-header";

class SecondaryService {
  get(fileDataId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Secondary/${fileDataId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  update(status, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Secondary/${fileDataId}`,
        status,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new SecondaryService();
